import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import styled from 'styled-components';
import { fetch_product_details } from 'services/apiSrv';
import Loader from 'components/widgets/loader';
// Styled Components
const DetailsCard = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  flex: 1;
  min-width: 300px;
`;

const Subtitle = styled.h2`
  font-size: 18px;
  margin-bottom: 12px;
  color: #555;
`;

const InfoText = styled.p`
  margin: 8px 0;
  font-size: 14px;
  color: #666;
`;

const ErrorMessage = styled.div`
  color: #ff4d4f;
  font-size: 16px;
  margin: 16px 0;
`;

const LoadingMessage = styled.div`
  font-size: 16px;
  color: #666;
  margin: 16px 0;
`;

const BasicDetails = () => {
  const { id: productSystemRef } = useParams();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['productDetails', productSystemRef],
    queryFn: () => fetch_product_details(productSystemRef),
    enabled: !!productSystemRef,
    retry: 2,
    staleTime: 5 * 60 * 1000,
  });

  if (isLoading) {
    return <Loader/>;
  }

  if (isError) {
    return <ErrorMessage>Error fetching product details: {error?.message || 'Something went wrong'}</ErrorMessage>;
  }

  if (!data?.data) {
    return <ErrorMessage>No product data available.</ErrorMessage>;
  }

  const { productName, productDescription, productPremium, basePremiumRate } = data.data[0];

  return (
    <DetailsCard>
      <Subtitle>Product Basic Details</Subtitle>
      <InfoText>Name: {productName || 'N/A'}</InfoText>
      <InfoText>Description: {productDescription || 'No description available'}</InfoText>
      <InfoText>Premium Maximum: {productPremium?.maximum || 'N/A'}</InfoText>
      <InfoText>Premium Minimum: {productPremium?.minimum || 'N/A'}</InfoText>
      <InfoText>Rate Type: {basePremiumRate?.rateType || 'N/A'}</InfoText>
      <InfoText>Rate Value: {basePremiumRate?.value || 'N/A'}</InfoText>
    </DetailsCard>
  );
};

export default BasicDetails;